import React from 'react'
import { Loader } from '@grofers/dock-design-kit'
import type { FullPageLoaderProps } from './FullPageLoader.types'

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ className = '' }) => {
  return (
    <div
      className={`flex flex-1 items-center justify-center bg-white ${className}`}
      role="status"
      aria-label="Loading"
    >
      <Loader showLoader size="lg" />
    </div>
  )
}

export default FullPageLoader
